import { LocalizedTypography } from '@mews-commander/ui';
import { FormSwitchField, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';

export const ToggleMfa = () => {
    const localize = useLocalizeText();

    return (
        <Stack vertical spacing="50">
            <LocalizedTypography
                textStyle="bodyMediumStrong"
                textKey={TextKey.TwoFactorAuthenticationEnforce}
                as="div"
            />
            <Stack distribution="space-between" spacing="200">
                <LocalizedTypography
                    textStyle="bodyMedium"
                    textKey={TextKey.TwoFactorAuthenticationEnforceDescription}
                    as="div"
                />
                <FormSwitchField
                    name="enforceAuthenticatorSetup"
                    label=""
                    aria-label={localize({ textKey: TextKey.TwoFactorAuthenticationEnforce })}
                />
            </Stack>
        </Stack>
    );
};
